// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KX0tW","clinicsSelect":"styles_clinicsSelect__39Upr"};